import { render, staticRenderFns } from "./OurCooperation.vue?vue&type=template&id=14a965c8&scoped=true&"
var script = {}
import style0 from "./OurCooperation.vue?vue&type=style&index=0&id=14a965c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a965c8",
  null
  
)

export default component.exports